// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.speech-bubble {
  position: absolute;
  top: -20px;
  left: 120px;
  background: white;
  border: 2px solid #3bbddb;
  border-radius: 15px;
  padding: 8px 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  min-width: 120px;
  max-width: 200px;
  animation: bubbleAppear 0.3s ease-out;
  pointer-events: auto !important;
  z-index: 10;
}

.speech-bubble-content {
  text-align: center;
  font-size: 0.85rem;
  line-height: 1.3;
}

.speech-bubble-text {
  color: #333;
  font-weight: 500;
}

.speech-bubble-link {
  color: #3bbddb;
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.2s ease;
}

.speech-bubble-link:hover {
  color: #2a9bb8;
  text-decoration: underline;
}

/* НОВЫЙ КОД - стили для кнопки помощи (ЗАКОММЕНТИРОВАТЬ ПРИ ОТКАТЕ) */
.speech-bubble-help-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.speech-bubble-help-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
}

.speech-bubble-help-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
/* КОНЕЦ НОВОГО КОДА - стили для кнопки помощи */

.speech-bubble-tail {
  position: absolute;
  left: -8px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 8px solid white;
}

.speech-bubble-tail::before {
  content: '';
  position: absolute;
  top: -8px;
  left: -2px;
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 8px solid #3bbddb;
}

@keyframes bubbleAppear {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Темная тема */
.dark-theme .speech-bubble {
  background: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;
}

.dark-theme .speech-bubble-text {
  color: #e2e8f0;
}

.dark-theme .speech-bubble-link {
  color: #63b3ed;
}

.dark-theme .speech-bubble-link:hover {
  color: #4299e1;
}

.dark-theme .speech-bubble-tail {
  border-right-color: #2d3748;
}

.dark-theme .speech-bubble-tail::before {
  border-right-color: #4a5568;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .speech-bubble {
    top: -10px;
    left: 80px;
    padding: 6px 10px;
    min-width: 100px;
    max-width: 150px;
  }
  
  .speech-bubble-content {
    font-size: 0.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/CatAnimation/SpeechBubble.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,sEAAsE;AACtE;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;AACA,gDAAgD;;AAEhD;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,yCAAyC;AACzC;EACE;IACE,UAAU;IACV,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".speech-bubble {\r\n  position: absolute;\r\n  top: -20px;\r\n  left: 120px;\r\n  background: white;\r\n  border: 2px solid #3bbddb;\r\n  border-radius: 15px;\r\n  padding: 8px 12px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n  min-width: 120px;\r\n  max-width: 200px;\r\n  animation: bubbleAppear 0.3s ease-out;\r\n  pointer-events: auto !important;\r\n  z-index: 10;\r\n}\r\n\r\n.speech-bubble-content {\r\n  text-align: center;\r\n  font-size: 0.85rem;\r\n  line-height: 1.3;\r\n}\r\n\r\n.speech-bubble-text {\r\n  color: #333;\r\n  font-weight: 500;\r\n}\r\n\r\n.speech-bubble-link {\r\n  color: #3bbddb;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: color 0.2s ease;\r\n}\r\n\r\n.speech-bubble-link:hover {\r\n  color: #2a9bb8;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* НОВЫЙ КОД - стили для кнопки помощи (ЗАКОММЕНТИРОВАТЬ ПРИ ОТКАТЕ) */\r\n.speech-bubble-help-button {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  border: none;\r\n  padding: 8px 16px;\r\n  border-radius: 20px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.speech-bubble-help-button:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\r\n  background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);\r\n}\r\n\r\n.speech-bubble-help-button:active {\r\n  transform: translateY(0);\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n/* КОНЕЦ НОВОГО КОДА - стили для кнопки помощи */\r\n\r\n.speech-bubble-tail {\r\n  position: absolute;\r\n  left: -8px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 0;\r\n  height: 0;\r\n  border-top: 8px solid transparent;\r\n  border-bottom: 8px solid transparent;\r\n  border-right: 8px solid white;\r\n}\r\n\r\n.speech-bubble-tail::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: -8px;\r\n  left: -2px;\r\n  width: 0;\r\n  height: 0;\r\n  border-top: 8px solid transparent;\r\n  border-bottom: 8px solid transparent;\r\n  border-right: 8px solid #3bbddb;\r\n}\r\n\r\n@keyframes bubbleAppear {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.8);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n/* Темная тема */\r\n.dark-theme .speech-bubble {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .speech-bubble-text {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .speech-bubble-link {\r\n  color: #63b3ed;\r\n}\r\n\r\n.dark-theme .speech-bubble-link:hover {\r\n  color: #4299e1;\r\n}\r\n\r\n.dark-theme .speech-bubble-tail {\r\n  border-right-color: #2d3748;\r\n}\r\n\r\n.dark-theme .speech-bubble-tail::before {\r\n  border-right-color: #4a5568;\r\n}\r\n\r\n/* Адаптивность для мобильных устройств */\r\n@media (max-width: 768px) {\r\n  .speech-bubble {\r\n    top: -10px;\r\n    left: 80px;\r\n    padding: 6px 10px;\r\n    min-width: 100px;\r\n    max-width: 150px;\r\n  }\r\n  \r\n  .speech-bubble-content {\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
